(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/coupon/coupon-row.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/coupon/coupon-row.js');
"use strict";

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const sportinfoPathNames = svs.components.sportinfo.common.constants.SportinfoPathNames;
const Trotting = svs.components.sport.sportTypes.SportTypes.Trotting;
const getAriaLabelForEvent = svs.components.poolBetting.ariaUtils.getAriaLabelForEvent;
class CouponRow extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "state", {
      redirect: false
    });
    this.handleMatchClick = this.handleMatchClick.bind(this);
  }
  handleMatchClick() {
    const _this$props = this.props,
      event = _this$props.event,
      history = _this$props.history,
      draw = _this$props.draw;
    const pathname = window.location.pathname;
    const getBigstatTab = () => {
      for (let j = 0; j < Object.keys(sportinfoPathNames).length; j++) {
        if (pathname.search(Object.values(sportinfoPathNames)[j]) !== -1) {
          return Object.values(sportinfoPathNames)[j];
        }
      }
      return null;
    };
    const bigstatTab = getBigstatTab();
    if (event.eventTypeId !== svs.challenge.constants.eventTypes.H2H) {
      if (svs.core.detect.formfactor.mobile()) {
        history.push(svs.challenge.helpers.correctDrawUrl(draw, event.eventNumber, bigstatTab) + history.location.search);
      } else {
        history.replace(svs.challenge.helpers.correctDrawUrl(draw, event.eventNumber, bigstatTab) + history.location.search);
      }
    }
  }
  render() {
    var _event$match;
    const _this$props2 = this.props,
      event = _this$props2.event,
      isSelected = _this$props2.isSelected,
      draw = _this$props2.draw,
      coupon = _this$props2.coupon,
      selectItemAction = _this$props2.selectItemAction,
      settings = _this$props2.settings;
    const redirect = this.state.redirect;
    const showInfo = Boolean(event.extraInfo);
    const isPlayer = event.participantType === 'Player';
    let classes = 'list-group-item padding draw-list-container';
    let participantNames = [];
    const isTrotting = (event === null || event === void 0 || (_event$match = event.match) === null || _event$match === void 0 || (_event$match = _event$match.sport) === null || _event$match === void 0 ? void 0 : _event$match.type) === Trotting;
    if (event.eventTypeId !== svs.challenge.constants.eventTypes.H2H) {
      classes += ' js-clickable clickable-list-group-item-default';
    }
    if (isSelected) {
      classes += ' current-match';
    }
    if (isPlayer) {
      participantNames = event.match.participants.map(participant => participant.h2HName);
    } else {
      participantNames = event.match.participants.map(participant => participant.mediumName);
    }
    const _ReactRouterDOM = ReactRouterDOM,
      Redirect = _ReactRouterDOM.Redirect;
    return React.createElement("li", {
      className: classes,
      onClick: () => this.handleMatchClick()
    }, redirect ? React.createElement(Redirect, {
      push: true,
      to: "/spela/".concat(draw.drawNumber, "/").concat(event.eventNumber, "/?gameId=").concat(svs.utils.url.queryString.gameId)
    }) : null, React.createElement("div", {
      "aria-label": getAriaLabelForEvent({
        eventTypeId: event.eventTypeId,
        awayParticipant: event.match.participants[1],
        homeParticipant: event.match.participants[0]
      }),
      className: "coupon-event-row"
    }, React.createElement("div", {
      className: "btn-bet btn-bet-challenge btn-bet-selected btn-bet-200 coupon-event-number"
    }, React.createElement("label", {
      className: "btn-bet-label"
    }, event.eventNumber)), React.createElement("div", {
      className: "coupon-event-description"
    }, React.createElement("div", {
      className: "f-400 f-condensed",
      translate: "no"
    }, isPlayer || isTrotting ? event.eventDescription : participantNames.join(' - ')), isPlayer ? React.createElement("div", null, React.createElement("div", {
      className: "f-400 fc-grey-500 f-condensed"
    }, participantNames.join(' - ')), React.createElement("div", {
      className: "f-150 fc-grey-500"
    }, event.eventComment)) : React.createElement("div", {
      className: "f-400 fc-grey-500 f-condensed"
    }, event.eventComment)), React.createElement("div", {
      className: "coupon-event-left-align"
    }, React.createElement("div", {
      className: "right"
    }, React.createElement(svs.challenge.Alternatives, {
      alternatives: event.outcomes,
      coupon: coupon,
      draw: draw,
      eventNumber: event.eventNumber,
      selectItemAction: selectItemAction
    })))), React.createElement("div", {
      className: "statistics-wrapper"
    }, React.createElement(svs.challenge.StatRow, {
      isVisible: settings.showOdds && !isPlayer,
      label: "Odds",
      outcomes: event.outcomes,
      statData: parseInt(event.eventTypeId, 10) === 1 ? event.odds : null,
      type: "odds"
    }), React.createElement(svs.challenge.StatRow, {
      isVisible: settings.showSvF,
      label: "Svenska folket",
      outcomes: event.outcomes,
      statData: event.svenskaFolket,
      type: "svf"
    }), React.createElement(svs.challenge.StatRow, {
      isVisible: settings.showLeagueAndSport && !isPlayer,
      label: "Sport och liga",
      statData: event.match,
      type: "sol"
    }), React.createElement(svs.challenge.StatRow, {
      isVisible: showInfo,
      statData: {
        extraInfo: event.extraInfo
      },
      type: "info"
    })));
  }
}
svs.challenge.CouponRow = CouponRow;

 })(window);